import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'File Name',
    field: 'fileName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Type',
    field: 'fileType',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Type Name',
    field: 'fileTypeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded By',
    field: 'uploadedByFullName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded On',
    field: 'uploadedOnText',
    filter: 'text',
    searchable: true,
  },
];
